<template>
    <div class="apply-filter">
        <div class="top-nav">
            <div class="item">具体应用</div>
            <div class="item">管型</div>
            <div class="item">处理通量/离心力</div>
        </div>
        <div class="main-content">
            <div class="item">
                <div class="option" :class="selectIndex[0] == index?'item-1-select': ''"
                                    v-for="(item, index) in applyCategory"
                                    :key="item.id"
                                    @click="handleClick(1, index, item)"
                                    >{{item.title}}</div>
            </div>
            <div class="item">
                <div class="option" :class="selectIndex[1] == index?'item-1-select': ''"
                                    v-for="(item, index) in secondCategory"
                                    :key="item.id"
                                    @click="handleClick(2, index, item)"
                                    >{{item.title}}</div>
            </div>
            <div class="item">
                <div class="option" :class="selectIndex[2] == index?'item-1-select': ''"
                                    v-for="(item, index) in threeCategory"
                                    :key="item.id" @click="handleClick(3, index, item)"
                                    >{{item.title}}</div>
            </div>
        </div>
    </div>
</template>

<script>
import { newProductCategory } from '@/api/centrifuge'
export default {
    data () {
        return {
            applyCategory: [], // 应用所有类别
            secondCategory: [], // 二级应用类别
            threeCategory: [], // 三级应用类别
            selectIndex: [] // 选中类别的下标
        }
    },
    created () {
        this.newProductCategoryPort()
    },
    methods: {
        selectType () {
            this.$emit('input', false)
        },
        // 手动单击
        // 所需参数 attr1: 是几级类别级别 attr2: 选中某类别级别下的选项的下标 attr3: 当前类别的所有选项数据
        handleClick (rank, indexOf, item) {
            this.$set(this.selectIndex, rank - 1, indexOf)
            // console.log(' this.selectIndex', indexOf)
            let children = null
            if (item.children) {
                children = item.children
            } else {
                this.selectType()
                console.log('直接搜索', item.id)
                this.$emit('typeIdChange', item.id)
            }
            switch (rank) {
            case 1:
                // 单击一级
                this.secondCategory = children
                this.threeCategory = []
                break
            case 2:
                // 单击二级
                this.threeCategory = item.children
                break
            case 3:
                // 单击三级
                // this.secondCategory = item.children
                break
            }
        },
        /** 网络请求 **/
        // 获取全部类别
        newProductCategoryPort () {
            newProductCategory().then(res => {
                if (res.errCode === 0) {
                    var data = res.data
                    this.applyCategory = data
                    console.log('获取全部类别', data)
                }
            })
        }
    }
}
</script>
<style lang="scss" scoped>
.apply-filter{
    width: 100%;
    height: 100vh;
    background: #ffffff;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    display: flex;
    flex-direction: column;
    .top-nav{
        display: flex;
        .item{
            height: rem(47);
            background: #81C5DA;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #fff;
            font-size: rem(12);
            &:nth-child(1){
                width: 30%;
            }
            &:nth-child(2){
                width: 35%;
            }
            &:nth-child(3){
                width: 35%;
            }
        }
    }
    .main-content{
        display: flex;
        flex: 1;
        overflow: hidden;
        .item{
            height: 100%;
            background: #fff;
            font-size: rem(12);
            padding-bottom: constant(safe-area-inset-bottom);
            padding-bottom: env(safe-area-inset-bottom);
            overflow: auto;
            -webkit-overflow-scrolling: touch;
            &:nth-child(1){
                width: 30%;
                background: #fff;
            }
            &:nth-child(2){
                width: 35%;
                background:#f6fdff;
            }
            &:nth-child(3){
                width: 35%;
                background: #F8F8F8;
            }
            .option{
                display: flex;
                align-items: center;
                justify-content: center;
                text-align: center;
                padding: rem(7) rem(10);
                min-height: rem(40);
                height: auto;
                position: relative;
            }
        }
        .item-1-select{
            background: #ebf8fc;
            color: #1c1d1d;
            &:after{
                content: '';
                height: 100%;
                width: rem(4);
                background: #81C5DA;
                position: absolute;
                top: 0;
                left: 0;
            }
        }
    }
}
</style>
